/*
 * @Author: mengxd
 * @CreateTime: 2021-06-07 16:21:14
 * @Description: 去上课
 */
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import lodash from 'lodash'
import { EnumProductTypeQuery } from '@xt/client/enums'
import { CourseType, CourseItem, MyCourseList } from '@xt/client/types/my-go-course'

type ActiveItemType = 'progressing' | 'wenfang' | CourseType

@Observer
@Component
export class MixinsGoCourse extends Vue {
  myProductList: MyCourseList & {
    progressingResultVOS: CourseItem[]
  } = {
    courseResultVOS: [],
    activityResultVOS: [],
    // 展览习作
    showResultVOS: [],
    selfStudyResultVOS: [],
    progressingResultVOS: [],
    specialCourseResults: [],
    // 展览辅导
    remedialShowResults: []
  }
  // 进行中课程
  get progressingCourse() {
    return this.myProductList.progressingResultVOS
  }
  // 直播课
  get liveCourse() {
    return (this.myProductList.courseResultVOS ?? []).map(v => lodash.set(v, 'type', EnumProductTypeQuery.Course))
  }
  // 日课
  get dayCourse() {
    return (this.myProductList.activityResultVOS ?? []).map(v => lodash.set(v, 'type', EnumProductTypeQuery.DayCourse))
  }
  // 自习课
  get selfStudyCourse() {
    return (this.myProductList.selfStudyResultVOS ?? []).map(v => lodash.set(v, 'type', EnumProductTypeQuery.SelfStudy))
  }
  // 展览课
  get exhibitionCourse() {
    return [...(this.myProductList.showResultVOS ?? []), ...(this.myProductList.remedialShowResults ?? [])]
      .map(v => (lodash.set(v, 'type', EnumProductTypeQuery.Exhibition), v))
      .sort((a, b) => b.successTime - a.successTime)
  }
  // 专题课
  get specialCourse() {
    return (this.myProductList.specialCourseResults ?? []).map(v => lodash.set(v, 'type', EnumProductTypeQuery.SpecialCourse))
  }

  courseList: Array<any> = []
  dataLoading = false
  tabCurIndex = 0
  tabListLength = 5
  changeTabHandler(item: { type: ActiveItemType; index: number }) {
    this.dataLoading = true
    this.tabCurIndex = item.index
    switch (item.type) {
      case 'course':
        this.courseList = this.liveCourse
        break
      case 'daycourse':
        this.courseList = this.dayCourse
        break
      case 'exhibition':
        this.courseList = this.exhibitionCourse
        break
      case 'selfstudy':
        this.courseList = this.selfStudyCourse
        break
      case 'progressing':
        this.courseList = this.myProductList.progressingResultVOS
        break
      case 'specialCourse':
        this.courseList = this.specialCourse
        break
    }
    setTimeout(() => {
      this.dataLoading = false
    }, 500)
  }

  mounted() {}
  updated() {}
  destroyed() {
    //this.Pagination.onReset()
  }
}
